<template>
  <div class="loading-view" v-show="visible">
    <van-loading size="40px" color="#1989fa" />
    <p class="loading-text">{{ text }}</p>
  </div>
</template>
  
<script>
import { Loading } from 'vant';
export default {
  name: 'LoadingView',
  components: {
    [Loading.name]: Loading
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '加载中...'
    }
  }
}
</script>
  
  <style scoped>
  .loading-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 999;
    /* padding-top: 120px; */
  }
  
  .loading-text {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
  }
  </style>  